<template>
  <div class="view-qualify-step-the-solutions">
    <div class="wrapper">
      <div class="main-title">
        <span class="icon-logo-manitou" :class="brandColor"></span>
        <span class="icon-flags" :class="brandColor"></span>
        <span class="title-text" v-html="$t('below_our_solutions_that_fit_your_needs')"></span>
      </div>

      <template v-if="displayContent">
        <transition name="fade">

          <div class="machines-solutions-container" v-if="machines.length > 0">
            <!--<div class="solution-type-title">
                <span class="classic-text">{{ $t('the_machine') }}</span>
                <span class="print-text">{{ $t('the_machines') }}</span>
            </div>

            <div class="machine-selection" v-if="machines.length > 1">
                <div class="tabs" v-if="!isPhone">
                <span
                    v-for="machine in machines"
                    :key="machine.identifier"
                    class="tab"
                    :class="{ active: selectedMachine === machine.identifier }"
                    @click="selectedMachine = machine.identifier"
                >
                    {{ machine.name }}
                </span>
                </div>
                <b-select
                    v-else
                    v-model="selectedMachine"
                    class="select-tab"
                    size="is-large"
                    rounded
                    expanded
                >
                    <option
                        v-for="machine in machines"
                        :key="machine.identifier"
                        :value="machine.identifier"
                    >
                        {{ machine.name }}
                    </option>"
                </b-select>
            </div>
            -->
            <div class="fieldsMachines" v-if="environments.find(env => env.slug === environment)">
              <h3><strong>{{ $t('environment') }} : </strong>{{ environments.find(env => env.slug === environment).name }}</h3>
<!--              <template v-for="fields in fieldsQualifyIndustry">
                <template v-if="fields">
                  <template v-for="(value, key) in fields">
                    <template v-if="value">
                      <h3 class="is-color-red">{{ getGroupBySlug(key) }}</h3>
                      <p v-if="value==='machineEnergy_Diesel'" :key="key">
                        {{ getFieldBySlug(key) ? getFieldBySlug(key).label : '' }} :
                        {{ $t('yes') }}</p>
                      <p v-else-if="value==='0'" :key="key">{{ getFieldBySlug(key) ? getFieldBySlug(key).label : '' }} :
                        {{ $t('no') }}</p>
                      <p v-else-if="key==='rampHeight'" :key="key">{{ $t('ramp_height') }} :
                        {{ getFieldBySlug(key) ? value + ' ' + getFieldBySlug(key).unit[unitType] : value }}</p>
                      <p v-else-if="key==='rampLength'" :key="key">{{ $t('ramp_length') }} :
                        {{ getFieldBySlug(key) ? value + ' ' + getFieldBySlug(key).unit[unitType] : value }}</p>
                      <p v-else :key="key">{{ getFieldBySlug(key) ? getFieldBySlug(key).label : '' }} :
                        {{ getFieldBySlug(key) ? value + ' ' + getFieldBySlug(key).unit[unitType] : value }}</p>
                    </template>
                  </template>
                </template>
              </template>-->
              <template v-for="(step, stepIndex) in environments.find(env => env.slug === environment).steps">
                <h2>{{ step.title }}</h2>
                <template v-for="group in step.survey.groups">
                  <h3 class="is-color-red">{{ group.label }}</h3>
                  <template v-for="question in group.questions">
                    <template v-if="question.type === 'ramp'">
                      <strong>{{ $t('ramp') }} :</strong>
                      <p>
                        {{ $tc('x_of_height', question.unit[unitType]) }} : {{ getValueBySlug(question, step.id) ? getValueBySlug(question, step.id).height : '' }}
                        {{ getValueBySlug(question, step.id) ? question.unit && question.unit.slug !== 'no_unit' ? question.unit[unitType] : '' : '-' }}
                      </p>
                      <p>
                        {{ $tc('x_of_length', question.unit[unitType]) }} : {{ getValueBySlug(question, step.id) ? getValueBySlug(question, step.id).length : '' }}
                        {{ getValueBySlug(question, step.id) ? question.unit && question.unit.slug !== 'no_unit' ? question.unit[unitType] : '' : '-' }}
                      </p>
                    </template>
                    <p v-else>
                      <strong>{{ question.label }} : </strong>
                      {{ question.answers.find(answer => answer.value === getValueBySlug(question, step.id)) ? question.answers.find(answer => answer.value === getValueBySlug(question, step.id)).label : getValueBySlug(question, step.id) }}
                      {{ getValueBySlug(question, step.id) ? question.unit && question.unit.slug !== 'no_unit' ? question.unit[unitType] : '' : '-' }}
                    </p>
                  </template>
                </template>
              </template>
            </div>

            <div class=" machines-details is-current"
                 :class="{'is-current': selectedMachine === machine.identifier}"
                 v-for="machine in machines">

              <div class="grey-container">
                <div class="main-picture" :style="`background-image: url(${machine.picture});`">
                  <div class="radial-gradient"></div>
                </div>
                <div class="machine-datas">
                  <h3 class="machine-title" :class="brandColor">
                    {{ machine.name }}
                  </h3>
                  <div class="print-picture">
                    <img :src="machine.picture" :alt="machine.name">
                  </div>
                  <div
                      v-for="highlight in machineHighlights(machine)"
                      :key="highlight.title"
                      class="highlight"
                  >
                    <div class="highlight-title" v-html="highlight.title"></div>
                    <div class="highlight-text" v-html="highlight.text"></div>
                  </div>


                </div>
              </div>
              <div class="key-features-wrap">
                <sheet-block-key-features :product="machine" :showFeatures="false"/>
                <router-link
                    :to="{ name: 'machine-sheet-summary', params: {id: (machine.parent ? machine.parent : machine.identifier), name: slugifyName(machine), saveRoute: true}}"
                    class="button is-primary is-large is-rounded is-uppercase see-machine-link"
                    :class="brandBackgroundColor"
                >
                  <span>{{ $t("see_the_machine") }}</span>
                  <span class="icon-arrow-right is-tiny is-right-side"></span>
                </router-link>
              </div>
              <hr class="print-text">
            </div>


          </div>

        </transition>

        <!--<transition name="fade">
            <div class="services-solutions-container" v-if="services.length > 0">
                <div class="solution-type-title">
                    {{ $t('the_available_services') }}
                </div>

                <div class="grey-container services-list">
                    <card-service
                        v-for="service in services"
                        :key="service.identifier"
                        class="content-item"
                        :datas="service"
                        :save-route="true"
                    />
                </div>
            </div>
        </transition>
        -->

        <div class="bottom-content">
          <p class="non-contractual-results-text">
            {{ $t('non_contractual_results') }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

import productService from '@/services/serli/product'

import TitledParagraphList from "@/components/TitledParagraph/TitledParagraphList";
import CardService from "@/components/Card/CardService.vue"
import Product from "@/services/serli/product";
import SheetBlockKeyFeatures from "@/components/SheetBlock/SheetBlockKeyFeatures";


const defaultPicture = require('@/assets/img/no_image_available.jpg');

export default {
  name: 'QualifyIndustryTheSolutions',
  components: {
    TitledParagraphList,
    CardService,
    SheetBlockKeyFeatures
  },
  data() {
    return {
      displayContent: false,
      machines: [],
      selectedMachine: null,
      services: [],
      currentGroup: '',
      currentStep: ''
    }
  },
  computed: {
    ...mapState({
      isPhone: state => state.settings.isPhone,
      unitType: state => state.settings.unitType,
      selectedMachineResults: state => state.qualifyIndustry.selectedMachineResults,
      fieldsQualifyIndustry: state => state.qualifyIndustry.fields,
      environment: state => state.qualifyIndustry.environment,
      environments: state => state.qualifyIndustry.environments,
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
  },

  created() {
    this.$store.commit('qualifyIndustry/setNextStepAllowed', false);
    this.startLoading();
    this.fetchMachinesDatas()
        .then(() => this.fetchServices())
        .finally(() => {
          this.displayContent = true;
          this.$store.commit('qualifyIndustry/setNextStepAllowed', true);
          this.stopLoading()
        })
  },
  methods: {
    async fetchMachinesDatas() {
      let machines = [];

      for (const selectedMachineResult of this.selectedMachineResults) {
        let machineDatas = await productService.show(selectedMachineResult, {
          locale: this.localeKebabFormat
        })
            .then(async (response) => {
              let machineDatas = response.data.data;
              machineDatas.picture = machineDatas.mainVisual + '?channel=medium'

              return machineDatas;
            });
        machines.push(machineDatas);
      }

      this.selectedMachine = machines[0].identifier;
      this.machines = machines;
    },
    machineHighlights(machine) {
      let paragraphs = [];
      for (let i = 1; i <= 5; i++)
        if (machine.values['title_key_point_' + i] && machine.values['key_point_description_' + i])
          paragraphs.push({
            title: machine.values['title_key_point_' + i].value.label,
            text: machine.values['key_point_description_' + i].value.label
          })
      return paragraphs;
    },
    async fetchServices() {
      await Product.services({brand: 'manitou', locale: this.localeKebabFormat,}).then(response => {
        this.services = response.data.data
        this.tabs.push({
          code: "services",
          label: this.$t('key_services'),

        })
      })
    },
    getValueBySlug(question, step) {
      let res = null
      this.fieldsQualifyIndustry.forEach((obj, index) => {
        if (typeof obj !== 'undefined' && index === step) {
          Object.keys(obj).forEach((key) => {
            if (key === question.slug) {
              res = obj[key]
            } else if (key.includes('ramp') && question.type === 'ramp') {
              res = {
                height: obj['rampHeight'],
                length: obj['rampLength'],
              }
            }
          })
        }
      })
      return res
    },
    // getFieldBySlug(key) {
    //   let res = null
    //   let currentEnv = this.environments.filter(env => env.slug === this.environment);
    //   if (currentEnv[0]) {
    //     currentEnv[0].steps.forEach(step => {
    //       step.survey.groups.forEach(group => {
    //         group.questions.forEach(question => {
    //           if (key === question.slug) {
    //             res = question
    //           } else if (key.includes('ramp') && question.type === 'ramp') {
    //             res = question
    //           }
    //         })
    //       })
    //     })
    //   }
    //   return res
    // },
    // getGroupBySlug(key) {
    //   console.log('method called')
    //   let res = null
    //   let currentEnv = this.environments.filter(env => env.slug === this.environment);
    //   if (currentEnv[0]) {
    //     currentEnv[0].steps.forEach(step => {
    //       step.survey.groups.forEach(group => {
    //         console.log(group.label);
    //         group.questions.forEach(question => {
    //           if (key === question.slug) {
    //             console.log('dans le if');
    //             // ici on met a jour le group si il est différent du precédent
    //             if (this.currentGroup !== group.label) this.currentGroup = group.label
    //             res = group.label
    //           } else if (key.includes('ramp') && question.type === 'ramp') {
    //             console.log('dans le else if');
    //             // ici on met a jour le group si il est différent du precédent
    //             if (this.currentGroup !== group.label) this.currentGroup = group.label
    //             res = group.label
    //           }
    //         })
    //       })
    //     })
    //   }
    //   return res
    // }
  },


}
</script>

<style lang="scss">
.view-qualify-step-the-solutions {

  .print-text {
    display: none;

    @media print {
      display: block;
    }
  }

  .main-title {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    line-height: 1.2;


    [class^="icon-"], [class*=" icon-"] {
      display: block;
      font-size: 80px;
    }

    .title-text {
      display: block;
      margin-top: -10px;
    }

    .icon-logo-manitou {
      display: none;

      @media print {
        margin-top: 150px;
        display: block;
      }
    }

  }

  .solution-type-title {
    margin-top: 60px;
    font-size: 23px;
    font-weight: 900;
    line-height: 0.96;

    @media print {
      text-align: left;
      font-size: 30px;
    }

    .classic-text {
      display: block;

      @media print {
        display: none;
      }
    }
  }


  .grey-container {
    display: flex;
    background-color: $light-grey;
    border-radius: 20px;
    flex: 0 0 calc(70%);

    @media print {
      display: block;
      background-color: $white;
    }

    @media #{$mq_phone} {
      display: block;
    }
  }

  .key-features-wrap {
    margin-left: 30px;
    margin-top: 35px;
    flex: 0 0 calc(30%);
    text-align: left;
    width: 80%;
    //padding-right:30px;
    @media print {
      margin-left: 0px;
    }

    .see-machine-link {
      margin-top: 20px;

      @media print {
        display: none !important;
      }
    }

    .the-label {
      @media print {
        margin-bottom: 10px;
      }
    }

    .label-value-item .value {
      width: auto;
    }

    .label-value-item {
      @media print {
        margin-bottom: 10px;
      }
    }

  }

  .fieldsMachines {
    display: none;
    text-align: left;
    margin-left: 30%;
    margin-right: 70%;
    width: 400px;
    margin-top: 85px;
    page-break-after: always;

    h2 {
      font-weight: bolder;
      font-size: 20px;
      margin-bottom: 10px;

      @media print {
        margin-top: 15px;
      }
    }

    @media print {
      display: block;
    }
  }

  .machines-solutions-container {
    text-align: center;

    .machine-selection {
      margin-top: 20px;

      @media print {
        display: none;
      }
    }

    .machines-details {
      display: flex;
      margin-top: 20px;

      @media print {
        display: block;
        page-break-after: always;
      }

      &:last-child {
        @media print {
          page-break-after: avoid;
        }
      }

      &.is-current {
        display: flex;

        @media print {
          display: block;
        }

        @media #{$mq_phone} {
          display: block;
        }
      }

      .main-picture {
        position: relative;
        flex: 0 0 35%;
        background-color: $white;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: auto 100%;

        @media print {
          display: none;
        }

        @media #{$mq_phone} {
          height: 250px;
          background-size: auto 70%;
          border-bottom-left-radius: 0;
          border-top-right-radius: 20px;
        }

        .radial-gradient {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
          background-image: radial-gradient(400px 400px at 50% 50%, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.19) 100%);
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;

          @media #{$mq_phone} {
            border-bottom-left-radius: 0;
            border-top-right-radius: 20px;
          }
        }
      }

      .print-picture {
        display: none;
        @media print {
          display: inline-block;
          width: 350px;
        }
      }

      .machine-datas {
        flex: 0 0 65%;
        padding: 40px;
        min-height: 400px;
        background-color: $light-grey;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        text-align: left;

        @media print {
          padding: 0;
          min-height: 0;
          margin-top: 40px;
          background-color: $white;
        }

        @media #{$mq_phone} {
          min-height: 0;
          border-bottom-left-radius: 20px;
        }

        .machine-title {
          font-family: $font_manitou;
          font-size: 25px;
          line-height: 1.2;
          text-transform: uppercase;
          margin-bottom: 30px;

          @media print {
            font-size: 20px;
          }
        }

        .highlight {
          &-title {
            font-size: 16px;
            font-weight: 700;
            text-transform: uppercase;
            margin: 15px 0 10px 0;
          }

          &-text {
            color: $medium-grey;
          }
        }

      }
    }
  }

  .services-solutions-container {
    text-align: center;

    @media print {
      text-align: left;
    }

    .services-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      margin: 20px 0;
      padding: 10px;
      text-align: left;

      @media print {
        display: block;
        margin: 30px 0 0 0;
        padding: 0;
      }

      @media #{$mq_phone} {
        margin: 20px 0;
      }

      .content-item {
        flex: 0 1 275px;
        margin: 10px;

        @media print {
          margin: 20px 0;
        }

        @media #{$mq_phone} {
          flex: 1 1 100%;
        }
      }
    }
  }

  .bottom-content {
    text-align: right;

    .non-contractual-results-text {
      display: block;
      margin-top: 40px;
    }
  }
}
</style>
